import React, { useEffect } from 'react';
import cx from 'classnames';
import useContactForm from '@/widget/ui/hooks/useContactForm';
import styles from './ContactForm.module.scss';

function ContactForm() {
  const {
    sending,
    fields,
    errors,
    getValues,
    fieldPlaceholder,
    privatePolicyUrl,
    setFocus,
    handleFocus,
    handleSubmit,
    onSubmit,
  } = useContactForm();

  const firstField = fields[0].name;
  useEffect(() => setFocus(firstField, { shouldSelect: true }), [firstField, setFocus]);

  return (
    <div className={styles.container}>
      <div className={styles.caption}>{window.ChatWidget.i18n.t('chat_widget.contact_form.caption')}</div>
      <div className={styles.form}>
        <form onSubmit={handleSubmit(onSubmit)}>
          {fields.map(({ name, active, props }) => (
            <div key={name}>
              <div
                onClick={() => handleFocus(name)}
                className={cx(
                  styles.inputContainer,
                  {
                    [styles.active]: active,
                    [styles.invalid]: errors[name],
                  },
                )}
              >
                <label
                  className={cx(
                    styles.label,
                    {
                      [styles.active]: active,
                      [styles.filled]: getValues(name) && getValues(name).length,
                    },
                  )}
                  htmlFor={name}
                >
                  {window.ChatWidget.i18n.t(`chat_widget.contact_form.fields.${name}`)}
                  *
                </label>
                <input
                  {...props}
                  placeholder={fieldPlaceholder[name]}
                  onBlur={() => handleFocus(name)}
                  onFocus={() => handleFocus(name)}
                  className={cx(
                    styles.input,
                    {
                      [styles.active]: active,
                      [styles.filled]: getValues(name) && getValues(name).length,
                    },
                  )}
                />
              </div>
              <div className={styles.error}>
                {errors[name] && window.ChatWidget.i18n.t(`chat_widget.contact_form.errors.${errors[name].message}`)}
              </div>
            </div>
          ))}
          {privatePolicyUrl
            && (
              <div className={styles.privatePolicy}>
                {window.ChatWidget.i18n.t('chat_widget.contact_form.private_policy.caption')}
                {' '}
                <a
                  rel="noreferrer"
                  target="_blank"
                  href={privatePolicyUrl}
                >
                  {`${window.ChatWidget.i18n.t('chat_widget.contact_form.private_policy.link')}`}
                </a>
              </div>
            )}
          <input className={cx(styles.button, { [styles.sending]: sending })} type="submit" disabled={sending} />
        </form>
      </div>
    </div>
  );
}

export default ContactForm;
